<!-- loader -->
@if (showSpinner) {
<div class="center">
    <div class="spinnerctr">
        <mat-progress-spinner class="spc-spinner" mode="indeterminate"></mat-progress-spinner>
    </div>
</div>
}
<!-- statistics and batch wrapper -->
<div class="statistics-wrapper fw fh" id="top">
    <div class="main-filter-wrapper">
        <div class="top-split fw">
            @if (false) {
            <div class="module-title">
                @if (!batch) {
                <span>{{'menuList.stat_continuous' | translate}}</span>
                }
                @if (batch) {
                <span>{{'menuList.batch' | translate}}</span>
                }
            </div>
            }
            <div class="filter-wrapper filter-parent">
                <form [formGroup]="statisticsForm" class="fw fh" (ngSubmit)="onFilterApply(true, true)">
                    @if (grapType==='manual') {
                    <div class="space-evenly-right common-form-field">
                        <mat-form-field appearance="outline" class="spc-form-field">
                            <mat-label appRemoveAriaOwns>{{'common.type' | translate}}</mat-label>
                            <mat-select formControlName="type" required (selectionChange)="onTypeChange()">
                                <mat-option value="Continous">Continuous</mat-option>
                                <mat-option value="Batch">Batch</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    }
                    <div class="drop-down-cntnr">
                        <mat-form-field appearance="outline" [style.width.%]="95">
                            <mat-label appRemoveAriaOwns>{{'common.line' | translate}}</mat-label>
                            <mat-select formControlName="line" (selectionChange)="lineChanged()" required
                                [disableOptionCentering]="true" #selectLine>
                                @if (selectLine.focused) {
                                <mat-option class="search-option" (keydown)="$event.stopPropagation()">
                                    <lib-mat-select-search [list]="lineList" [searchProperties]="['linename']"
                                        (filtered)="lineListFilter = $event">
                                    </lib-mat-select-search> </mat-option>} @for (line of lineListFilter; track line) {
                                <mat-option [value]="line">
                                    {{line?.linename}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="drop-down-cntnr">
                        <mat-form-field appearance="outline" [style.width.%]="95">
                            <mat-label appRemoveAriaOwns>{{'common.machine' | translate}}</mat-label>
                            <mat-select #select formControlName="machine" required multiple
                                (openedChange)="getParameter($event)">
                                @if (select.focused) {
                                <mat-option class="search-option" (keydown)="$event.stopPropagation()">
                                    <lib-mat-select-search [list]="machineList" [searchProperties]="['machinename']"
                                        (filtered)="machineListFilter = $event">
                                    </lib-mat-select-search> </mat-option>} <div class="select-all">
                                    <mat-checkbox color="primary" [(ngModel)]="allSelected"
                                        [ngModelOptions]="{standalone: true}" (change)="toggleAllSelection()">Select All
                                    </mat-checkbox>
                                </div>
                                @for (machine of machineListFilter; track machine) {
                                <mat-option (click)="optionClick()" [value]="machine">
                                    {{machine?.machinename}}</mat-option>
                                }
                            </mat-select>
                            <mat-hint *ngIf="statisticsForm.controls['machine'].hasError('noMachineFound')"
                                class="sku-mat-error">
                                <strong>{{'common.no_machine' | translate}}</strong>
                            </mat-hint>
                        </mat-form-field>
                    </div>
                    <!-- parameter -->
                    <div class="drop-down-cntnr">
                        <mat-form-field appearance="outline" [style.width.%]="95">
                            <mat-label appRemoveAriaOwns>{{'common.select_params' | translate}}</mat-label>
                            <mat-select #selectParameter (openedChange)="closeParam($event)"
                                [formControl]="parametersFilter" multiple>
                                @if (selectParameter.focused) {
                                <mat-option class="search-option" (keydown)="$event.stopPropagation()">
                                    <lib-mat-select-search [list]="paramList" [searchProperties]="['parametername']"
                                        (filtered)="paramListFilter = $event">
                                    </lib-mat-select-search> </mat-option>} <div class="select-all-parameter">
                                    <mat-checkbox color="primary" [(ngModel)]="allParameterSelected"
                                        [ngModelOptions]="{standalone: true}" (change)="toggleAllParameterSelection()">
                                        Select All
                                    </mat-checkbox>
                                </div>
                                @for (param of paramListFilter; track param) {
                                <mat-option #par [value]="param" (click)="setPageIndex();optionParameterClick()">
                                    {{param?.parametername}}</mat-option>
                                }
                            </mat-select>
                            @if (grapTypes==='summary') {
                            <mat-hint style="font-size: 9px; color: #00000099;"
                                [ngClass]="{'error sku-mat-error': max20}">
                                <strong>{{'common.max20para' | translate}}</strong>
                            </mat-hint>
                            }
                        </mat-form-field>
                    </div>
                    <!-- sampling -->
                    @if (isCapability) {
                    <div class="drop-down-cntnr">
                        <mat-form-field appearance="outline" [style.width.%]="95">
                            <mat-label appRemoveAriaOwns> {{'common.SubGroupSampling' | translate}}</mat-label>
                            <mat-select formControlName="sampling" required>
                                @for (sampling of samplingGroup; track sampling) {
                                <mat-option [value]="sampling">
                                    {{sampling}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    }
                    <!------------------------------------------------------------------period local-->
                    <div class="drop-down-cntnr">
                        <mat-form-field appearance="outline" [style.width.%]="95" class="truncate-label">
                            <mat-label appRemoveAriaOwns>{{'common.period_local' | translate}}</mat-label>
                            <mat-select formControlName="period" (selectionChange)="periodChanged($event)" required>
                                @for (period of periodList; track period) {
                                <mat-option (click)="periodClick()" [value]="period">
                                    {{period?.name}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="drop-down-cntnr">
                        <mat-form-field appearance="outline" class="fw spc-form-field" [style.width.%]="95">
                            <mat-label>{{'common.sku' | translate}}</mat-label>
                            <input type="text" placeholder="SKU" matInput required formControlName="sku"
                                (change)="setAutoCompleteStatus('sku',false,true)" [matAutocomplete]="autoSku">
                            <mat-autocomplete #autoSku="matAutocomplete" [displayWith]="utilSer.mapSKUName">
                                @for (sku of filteredList.sku ; track sku) {
                                <mat-option [value]="sku" [matTooltip]="sku.skuName" matTooltipPosition="right"
                                    (click)="[setAutoCompleteStatus('sku',true,true), getSkuRun()]"
                                    [class.inactive-optionlist]="sku?.IsActive === false">
                                    {{sku?.skuName}}</mat-option>
                                }
                            </mat-autocomplete>
                            @if (!autoCompleteStatus?.sku &&
                            statisticsForm?.controls?.sku.touched &&
                            statisticsForm?.controls?.sku.dirty) {
                            <mat-hint class="error" align="end">
                                {{'common.sku_alert' | translate}} <strong>{{'common.list' | translate}}</strong>!
                            </mat-hint>
                            }
                            <mat-hint *ngIf="statisticsForm.controls['sku'].hasError('noSkuFound')"
                                class="sku-mat-error">
                                <strong> {{'spc.dashboard.sku_alert2' | translate}}</strong>
                            </mat-hint>
                        </mat-form-field>
                    </div>
                    @if (statisticsForm?.value?.period?.code === 'custom') {
                    <div class="drop-down-cntnr">
                        @if (statisticsForm?.value?.period?.code === 'custom') {
                        <mat-form-field [style.width.%]="95" appearance="outline">
                            <mat-label appRemoveAriaOwns>{{'common.sku_run' | translate}}</mat-label>
                            <mat-select formControlName="skurunperiod" required>
                                @for (run of skuRunList; track run) {
                                <mat-option [value]="run">
                                    {{run?.startTime| date:'MMM d, y, HH:mm'}} -
                                    @if (run?.endTime) {
                                    <span> {{run?.endTime | date:'MMM d, y, HH:mm'}}</span>
                                    }
                                    @if (!run?.endTime) {
                                    <span> {{'common.till_now' | translate}}</span>
                                    }
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        }
                    </div>
                    }
                    <div class="">
                        <button mat-raised-button class="edit-btn spc-btn" color="primary" type="submit" [disabled]="!statisticsForm.valid || (statisticsForm?.value?.period?.code === 'custom' &&
                           statisticsForm?.value?.sku?.code ==='allSKUs' ) || this.parametersFilter.value.length ===0">
                            <img src="assets/images/play_button.svg" alt="Submit">
                        </button>
                    </div>
                </form>
            </div>
        </div>
        @if (masterData?.length > 0 && continousFilter?.period && grapTypes!=='summary') {
        <div class="bottom-split font-common">
            <div class="left-split">
                <div class="rule spc-charts rule-violation">
                    <mat-checkbox class="unilever-spc-checkbox critial-aa criticality spc-charts chart-font-header"
                        (change)="onFilterApply()" [(ngModel)]="criticalityFilter.AA">
                        {{'common.aa' | translate}} </mat-checkbox>
                    <mat-checkbox class="unilever-spc-checkbox critial-a criticality spc-charts chart-font-header"
                        (change)="onFilterApply()" [(ngModel)]="criticalityFilter.A">
                        {{'common.a' | translate}} </mat-checkbox>
                    <mat-checkbox class="unilever-spc-checkbox  critial-b criticality spc-charts chart-font-header"
                        (change)="onFilterApply()" [(ngModel)]="criticalityFilter.B">
                        {{'common.b' | translate}} </mat-checkbox>
                    <mat-checkbox class="unilever-spc-checkbox  critial-c criticality spc-charts chart-font-header"
                        (change)="onFilterApply()" [(ngModel)]="criticalityFilter.C">
                        {{'common.c' | translate}} </mat-checkbox>
                </div>
            </div>
            <div class="right-split">
                <div class="toggle-btn charts-toogle pr-2">
                    <mat-button-toggle-group name="chart-toggle" [value]="toggleType" (change)="onToggle($event)">
                        <mat-button-toggle [hidden]="isCapability" value="timeseries" class="chart-font-header">
                            {{'common.time_series' |
                            translate}}</mat-button-toggle>
                        <mat-button-toggle [hidden]="isCapability" value="histogram" class="chart-font-header">
                            {{'common.histogram' | translate}}
                        </mat-button-toggle>
                        <mat-button-toggle [hidden]="!isCapability" value="x" class="chart-font-header">X Bar
                        </mat-button-toggle>
                        <mat-button-toggle [hidden]="!isCapability" value="r" class="chart-font-header">R
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                @if (statisticsForm?.value?.period?.code !== 'custom' && statisticsForm?.value?.sku?.code === 'allSKUs'
                &&
                latestRunningSKU?.length) {
                <div class="latest-sku chart-font-header">
                    <span class="label">{{'common.runing_sku' | translate}} - </span>
                    <span class="value">{{latestRunningSKU}}</span>
                </div>
                }
                <!----------------------------------------------------Time Test--------------------->
                @if (appliedFilter?.status) {
                <div class="filter-info">
                    @if (appliedFilter?.period?.code === 'custom') {
                    <div class="custom">
                        <!-- <div *ngFor="let run of skuRunList" [value]="run"> -->
                        <span>{{this.statisticsForm.value.skurunperiod?.startTime| date:'MMM d, y, HH:mm'}}</span>
                        &nbsp;
                        <span>-</span>&nbsp;
                        <span>{{this.statisticsForm.value.skurunperiod?.endTime | date:'MMM d, y, HH:mm'}}</span>
                        <!-- </div>  -->
                        <!-- <span>{{this.statisticsForm.value.skurunperiod | json}}</span> -->
                    </div>
                    }
                    @if (appliedFilter?.period?.code !== 'custom' && !batch) {
                    <div class="live chart-font-header">
                        <div class="icon"></div>
                        <span>{{'common.live' | translate}}</span>
                    </div>
                    }
                </div>
                }
            </div>
        </div>
        }
    </div>
    <div class="graphs-wrapper">
        @if (!masterData?.length && this.grapTypes!=='summary') {
        <div class="no-data">
            <span>{{'common.statistics_no_Data' | translate}}.</span>
        </div>
        }
        @if (this.grapTypes !=='summary') {
        @for (item of masterData | slice:firstIndex:lastIndex; track item; let i = $index) {
        <div class="graphs-cntnr">
            <div style="border-bottom: 1px solid #ebebeb">
                <div class="header chart-filter-header continuous spc-charts">
                    <div class="parameter-details-wrapper fh spc-charts">
                        <div class="criticality spc-charts" [ngClass]="{
                                        'aa':$any(item)?.classification === 'AA',   
                                         'a':$any(item)?.classification === 'A',   
                                         'b':$any(item)?.classification === 'B',   
                                         'c':$any(item)?.classification === 'C' 
                                      }">
                            <span>{{$any(item)?.classification}}</span>
                        </div>
                        <div class="main-dtls spc-charts chart-font-header">
                            <div class="param-name spc-charts" [matTooltip]="$any(item)?.parametername">
                                <span>{{$any(item)?.parametername}}</span>
                            </div>
                            <div class="specification spc-charts">
                                {{$any(item)?.unit}}
                            </div>
                        </div>
                    </div>
                    <div class="partition param-title"></div>
                    <div class="filter-wrapper fh font-common">
                        <div class="toggle-outlier mr-3">
                            <div class="statistics-btn button-toggle">
                                <div class="statistics-btn btn-align tile-toggle">
                                    <div class="custom-control custom-switch">
                                        <label class="switch ml-2">
                                            <input type="checkbox" (click)="threeWayBtn1(item,$event,i)"
                                                [id]="'with-Outlier_' + i"
                                                [checked]="!($any(item)?.filter?.outliers) && !($any(item)?.filter?.obiousOutlier)">
                                            <span class="slider round" id="'with-Outlier"
                                                title="{{'common.without_obvious_outlier' | translate}}"></span>
                                        </label>
                                        <label class="switch ml-2">
                                            <input type="checkbox" (click)="threeWayBtn1(item,$event,i)"
                                                [id]="'with-ob-Outlier_' + i"
                                                [checked]="!($any(item)?.filter?.outliers) && $any(item)?.filter?.obiousOutlier">
                                            <span class="slider round" id="with-ob-Outlier"
                                                title="{{'common.with_obvious_outlier' | translate}}"></span>
                                        </label>
                                        <label class="switch ml-2">
                                            <input type="checkbox" (click)="threeWayBtn1(item,$event,i)"
                                                [id]="'without-Outlier_' + i" [checked]="$any(item)?.filter?.outliers">
                                            <span class="slider round" id="without-Outlier"
                                                title="{{'common.outlier' | translate}}"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--------------------------Test-----Download------------------------>
                        <div class="partition param-title mr-3"></div>
                        @if ($any(item)?.timeSeriesData?.length) {
                        <div class="chart-options">
                            @if ($any(item)?.timeSeriesData?.length) {
                            <div class="export" matRipple (click)="generateCSV(item)"></div>
                            }
                        </div>
                        }
                    </div>
                </div>
            </div>
            <div class="graph-grp">
                @if (toggleType!=='histogram') {
                <div class="split time-series fh">
                    <div class="graph-right-split">
                        <div class="rules-selection rule-filter chart-font-header">
                            @if (!$any(item)?.filter?.outliers) {
                            <div class="rule">
                                <mat-checkbox class="unilever-spc-checkbox rule1 filter-spacing"
                                    [(ngModel)]="$any(item).filter.rule1">
                                    {{'common.rule_1' | translate}}
                                </mat-checkbox>
                                <mat-checkbox class="unilever-spc-checkbox rule6 laptop-s-separator filter-spacing"
                                    [(ngModel)]="$any(item).filter.rule6">
                                    {{'common.rule_6' | translate}}
                                </mat-checkbox>
                                <mat-checkbox class="unilever-spc-checkbox rule7 filter-spacing"
                                    [ngClass]="{'menu-expanded-checkbox': menuExpanded === true}"
                                    [(ngModel)]="$any(item).filter.rule7">
                                    {{'common.rule_7' | translate}}
                                </mat-checkbox>
                                <mat-checkbox class="unilever-spc-checkbox usl-lsl laptop-s-separator lsl-usl"
                                    title="{{'common.lsl_usl' | translate}}" [(ngModel)]="$any(item).filter.usl_lsl">
                                    <span>{{'common.lsl_usl' | translate}}</span>
                                </mat-checkbox>
                            </div>
                            }
                            @if ($any(item)?.filter?.outliers) {
                            <div class="rule-filter">
                                <mat-checkbox class="unilever-spc-checkbox usl-lsl"
                                    [(ngModel)]="$any(item).filter.usl_lsl">
                                    {{'common.lsl_usl' | translate}}
                                </mat-checkbox>
                            </div>
                            }
                        </div>
                        <div class="partition"></div>
                        <div class="kpi-dtls-wrapper chart-font-header">
                            <div class="kpi">
                                <span class="calc-label">{{'common.points' | translate}}:</span>
                                @if ($any(item)?.kpi?.totalDataPoints && !isCapability &&
                                !($any(item)?.filter?.outliers) &&
                                !($any(item)?.filter?.obiousOutlier)) {
                                <span class="calc-value">{{$any(item)?.kpi?.totalDataPoints}}</span>
                                }
                                @if ($any(item)?.kpi?.totalPoints && !isCapability && !($any(item)?.filter?.outliers) &&
                                $any(item)?.filter?.obiousOutlier) {
                                <span class="calc-value">{{$any(item)?.kpi?.totalPoints}}</span>
                                }
                                <!-- @if ($any(item)?.kpi?.totalPoints && !isCapability && $any(item)?.filter?.outliers -->
                                @if ($any(item)?.kpi?.totalDataPointsInlcudingManualOutlier && !isCapability &&
                                $any(item)?.filter?.outliers
                                ) {
                                <span
                                    class="calc-value">{{$any(item)?.kpi?.totalDataPointsInlcudingManualOutlier}}</span>
                                }
                                @if ($any(item)?.kpi?.totalPoints && isCapability) {
                                <span class="calc-value">{{$any(item)?.kpi?.totalPoints}}</span>
                                }
                            </div>
                            <div class="kpi sd spc-charts">
                                @if (isCapability) {
                                <span class="label spc-charts calc-label">
                                    {{'common.sigma' | translate}}:</span>
                                }
                                @if (!isCapability) {
                                <span class="label spc-charts calc-label">
                                    {{'common.sd' | translate}}:</span>
                                }
                                <!-- @if (!($any(item)?.filter?.obiousOutlier)) { -->
                                @if (!$any(item)?.filter?.obiousOutlier && !$any(item)?.filter?.outliers) {
                                <span
                                    class="sdv value scp spc-charts calc-value">{{getSigmaValue($any(item)?.kpi?.sigmaval)}}</span>
                                }
                                @if ($any(item)?.filter?.obiousOutlier) {
                                <span
                                    class="scp sdv value spc-charts calc-value">{{$any(item)?.kpi?.withOutliersSigmaval?.toFixed(2)}}</span>
                                }
                                @if ( $any(item)?.filter?.outliers){
                                <span class="sdv value scp spc-charts calc-value">
                                    {{$any(item)?.kpi?.includingManualOutliersSigmaval?.toFixed(2)}}</span>
                                }
                            </div>
                            <div class="kpi cp spc-charts spc-charts">
                                @if (isCapability) {
                                <span class="label spc-charts calc-label">
                                    {{'common.cp' | translate}}:</span>
                                }
                                @if (!isCapability) {
                                <span class="label spc-charts calc-label">
                                    {{'common.pp' | translate}}:</span>
                                }
                                @if (!$any(item)?.filter?.obiousOutlier && !$any(item)?.filter?.outliers) {
                                <span class="value scp spc-charts">
                                    @if ((getSigmaValue($any(item)?.kpi?.sigmaval) === 0 || $any(item)?.kpi?.xcp > 50 ||
                                    $any(item)?.kpi?.xcp === null)
                                    &&
                                    $any(item)?.timeSeriesData) {
                                    <span class="cp-infinity">
                                        <img class="infinite-symbol" alt="infinite" src="assets/images/infinity.svg">
                                    </span>
                                    }
                                    @if ($any(item)?.kpi?.sigmaval !== 0 && !($any(item)?.kpi?.xcp > 50)) {
                                    <span class="cp-value calc-value">
                                        {{$any(item)?.kpi?.xcp?.toFixed(2)}}
                                    </span>
                                    }
                                </span>
                                }
                                @if ($any(item)?.filter?.obiousOutlier) {
                                <span class="scp value">
                                    @if (($any(item)?.kpi?.withOutliersSigmaval === 0 ||
                                    $any(item)?.kpi?.xcpWithOutLiers > 50 ||
                                    $any(item)?.kpi?.xcpWithOutLiers === null) && $any(item)?.timeSeriesData) {
                                    <span class="scp-infinity">
                                        <img class="infinite-symbol" alt="infinite" src="assets/images/infinity.svg">
                                    </span>
                                    }
                                    @if ($any(item)?.kpi?.withOutliersSigmaval !== 0 &&
                                    !($any(item)?.kpi?.xcpWithOutLiers > 50)) {
                                    <span class="scp-value calc-value">
                                        {{$any(item)?.kpi?.xcpWithOutLiers?.toFixed(2)}}
                                    </span>
                                    }
                                </span>
                                }
                                @if ($any(item)?.filter?.outliers){
                                <span class="value scp spc-charts">
                                    @if (($any(item)?.kpi?.includingManualOutliersSigmaval === 0 ||
                                    $any(item)?.kpi?.xcpIncludingManualOutliers > 50 ||
                                    $any(item)?.kpi?.xcpIncludingManualOutliers === null) && $any(item)?.timeSeriesData)
                                    {
                                    <span class="cp-infinity">
                                        <img class="infinite-symbol" alt="infinite" src="assets/images/infinity.svg">
                                    </span>
                                    }
                                    @if ($any(item)?.kpi?.includingManualOutliersSigmaval !== 0 &&
                                    !($any(item)?.kpi?.xcpIncludingManualOutliers > 50)) {
                                    <span class="cp-value calc-value">
                                        {{$any(item)?.kpi?.xcpIncludingManualOutliers?.toFixed(2)}}
                                    </span>
                                    }
                                </span>
                                }
                            </div>
                            <div class="kpi cpk">
                                @if (isCapability) {
                                <span class="label calc-label">{{'common.cpk' |
                                    translate}}:</span>
                                }
                                @if (!isCapability) {
                                <span class="label calc-label">{{'common.ppk' |
                                    translate}}:</span>
                                }
                                @if (!($any(item)?.filter?.obiousOutlier) && !($any(item)?.filter?.outliers)) {
                                <span class="value scpk">
                                    @if (($any(item)?.kpi?.sigmaval === 0 || $any(item)?.kpi?.xcpk > 50 ||
                                    $any(item)?.kpi?.xcpk === null)
                                    &&
                                    $any(item)?.timeSeriesData) {
                                    <span class="cpk-infinity">
                                        <img class="infinite-symbol" alt="infinite" src="assets/images/infinity.svg">
                                    </span>
                                    }
                                    @if ($any(item)?.kpi?.sigmaval !== 0 && !($any(item)?.kpi?.xcpk > 50)) {
                                    <span class="cpk-value calc-value">
                                        {{$any(item)?.kpi?.xcpk?.toFixed(2)}}
                                    </span>
                                    }
                                </span>
                                }
                                @if ($any(item)?.filter?.obiousOutlier) {
                                <span class="scpk value">
                                    @if (($any(item)?.kpi?.withOutliersSigmaval === 0 ||
                                    $any(item)?.kpi?.xcpkWithOutLiers > 50 ||
                                    $any(item)?.kpi?.xcpkWithOutLiers === null) && $any(item)?.timeSeriesData) {
                                    <span class="scpk-infinity">
                                        <img class="infinite-symbol" alt="infinite" src="assets/images/infinity.svg">
                                    </span>
                                    }
                                    @if ($any(item)?.kpi?.withOutliersSigmaval !== 0 &&
                                    !($any(item)?.kpi?.xcpkWithOutLiers > 50)) {
                                    <span class="scpk-value calc-value">
                                        {{$any(item)?.kpi?.xcpkWithOutLiers?.toFixed(2)}}
                                    </span>
                                    }
                                </span>
                                }
                                @if ($any(item)?.filter?.outliers) {
                                <span class="value scpk">
                                    @if (($any(item)?.kpi?.includingManualOutliersSigmaval === 0 ||
                                    $any(item)?.kpi?.xcpkIncludingManualOutliers > 50 ||
                                    $any(item)?.kpi?.xcpkIncludingManualOutliers === null) &&
                                    $any(item)?.timeSeriesData)
                                    {
                                    <span class="cpk-infinity">
                                        <img class="infinite-symbol" alt="infinite" src="assets/images/infinity.svg">
                                    </span>
                                    }
                                    @if ($any(item)?.kpi?.includingManualOutliersSigmaval !== 0 &&
                                    !($any(item)?.kpi?.xcpkIncludingManualOutliers > 50)) {
                                    <span class="cpk-value calc-value">
                                        {{$any(item)?.kpi?.xcpkIncludingManualOutliers?.toFixed(2)}}
                                    </span>
                                    }
                                </span>
                                }
                            </div>
                            <div class="avg">
                                <span class="label calc-label">{{'common.avg' | translate}}:</span>
                                @if (!$any(item)?.filter?.obiousOutlier && !$any(item)?.filter?.outliers) {
                                <span class="value calc-value">{{$any(item)?.kpi?.avg?.toFixed(2)}}</span>
                                }
                                @if (($any(item)?.filter?.obiousOutlier)) {
                                <span class="value calc-value">{{$any(item)?.kpi?.withOutliersAvg?.toFixed(2)}}</span>
                                }
                                @if ($any(item)?.filter?.outliers) {
                                <span
                                    class="value calc-value">{{$any(item)?.kpi?.includingManualOutliersAvg?.toFixed(2)}}</span>
                                }
                            </div>
                        </div>
                        <div class="partition"></div>
                        <!------------------------------------------------------------MarkAsOutlier Allocation-->
                        @if ($any(item).datasource!=='SQL') {
                        <div class="outlier-select">
                            <ng-template
                                [ngxPermissionsOnly]="['Statistics Continuous Update', 'Statistics Batch Update']">
                                @if (MarkAsOutlierOnHistoricalData && MarkAsOutlierOnwithobviousoutlier) {
                                <span
                                    [ngClass]="selectedParam?.id === $any(item)?.id && selectedPoints?.length !== 0 ?'manual-outlier-btn':'disable-pop'"
                                    (click)="openMarkAsOutlierPopup(item);"
                                    [hidden]="!($any(item)?.timeSeriesData?.length && !$any(item)?.filter?.outliers) || $any(item)?.allOutliers || isCapability"
                                    [outsideClick]="true" containerClass="outlier-info-popover">
                                    {{'common.mark_as_outlier' | translate}}
                                </span>
                                }
                                @if (MarkAsOutlierOnHistoricalData) {
                                <span class="manual-outlier-btn" (click)="removeManualOutliers(item)"
                                    [hidden]="!($any(item)?.timeSeriesData?.length && $any(item)?.filter?.outliers) || !$any(item)?.manualOutlierPresent || isCapability">
                                    {{'common.remove_outlier' | translate}}</span>
                                }
                            </ng-template>
                        </div>
                        }
                    </div>
                    <ng-template #markAsOutlier>
                        <app-outliers-info-capture [selectedPoints]="selectedPoints" [selectedParam]="selectedParam"
                            (afterSubmit)="afterOutlierSubmit($event)">
                        </app-outliers-info-capture>
                    </ng-template>
                    <div class="tdp pl-4">
                        <app-chart-yzoom [paramDtls]="item" (yzoomSubmit)="setYBound(item,$event)">
                        </app-chart-yzoom>
                    </div>
                    @if (batch || isCapability) {
                    <div class="chart-wrapper fh fw">
                        <app-c3-batch-series [data]="$any(item)?.timeSeriesData | ruleOutlierFilter : $any(item)?.filter?.usl_lsl: $any(item)?.filter?.rule1: $any(item)?.filter?.rule6 : $any(item)?.filter?.rule7 : $any(item)?.filter?.outliers : $any(item)?.filter?.obiousOutlier :
                            $any(item)?.yzoom?.zoom : $any(item)?.isHistogram" [kpi]="$any(item)?.kpi"
                            [paramName]="$any(item)?.parametername" [rule1Enabled]="$any(item)?.filter?.rule1"
                            [rule6Enabled]="$any(item)?.filter?.rule6" [rule7Enabled]="$any(item)?.filter?.rule7"
                            [outliers]="$any(item)?.filter?.outliers" [uslLsl]="$any(item)?.filter?.usl_lsl"
                            [redZone]="$any(item)?.filter?.redZone" [yzoom]="$any(item)?.yzoom"
                            [isCapability]="isCapability" (pointSelection)="selectedPointsChange($event,item)">
                        </app-c3-batch-series>
                    </div>
                    }
                    @if (!batch && !isCapability) {
                    <div class="chart-wrapper fh fw">
                        <app-c3-time-series [data]="$any(item)?.timeSeriesData | ruleOutlierFilter : $any(item)?.filter?.usl_lsl: $any(item)?.filter?.rule1: $any(item)?.filter?.rule6 : $any(item)?.filter?.rule7 : $any(item)?.filter?.outliers : $any(item)?.filter?.obiousOutlier :
                            $any(item)?.yzoom?.zoom : $any(item)?.isHistogram" [kpi]="$any(item)?.kpi"
                            [paramName]="$any(item)?.parametername" [rule1Enabled]="$any(item)?.filter?.rule1"
                            [rule6Enabled]="$any(item)?.filter?.rule6" [rule7Enabled]="$any(item)?.filter?.rule7"
                            [outliers]="$any(item)?.filter?.outliers" [uslLsl]="$any(item)?.filter?.usl_lsl"
                            [redZone]="$any(item)?.filter?.redZone" [yzoom]="$any(item)?.yzoom"
                            (pointSelection)="selectedPointsChange($event,item)">
                        </app-c3-time-series>
                    </div>
                    }
                </div>
                }
                @if (toggleType==='histogram') {
                <div class="split histogram fh">
                    <div class="chart-wrapper fh fw">
                        <app-histogram [data]="$any(item)?.timeSeriesData | ruleOutlierFilter : $any(item)?.filter?.usl_lsl: $any(item)?.filter?.rule1: $any(item)?.filter?.rule6 : $any(item)?.filter?.rule7 : $any(item)?.filter?.outliers : $any(item)?.filter?.obiousOutlier :
                            $any(item)?.yzoom?.zoom : $any(item)?.isHistogram" [kpi]="$any(item)?.kpi"
                            [outliers]="$any(item)?.filter?.outliers" [uslLsl]="$any(item)?.filter?.usl_lsl">
                        </app-histogram>
                    </div>
                </div>
                }
            </div>
            @if ($any(item)?.timeSeriesData) {
            <div class="zoom">
                <!-- <div class="icon-right" *ngIf="$any(item)?.timeSeriesData && appliedFilter?.period?.code === 'custom'">
                          <button mat-raised-button [ngClass]="{'graph-change-disable': item.chartfirstIndex===0}"
                            class="prev-next-button" color="primary"
                            (click)="chartChange(item, item.chartfirstIndex,'back')"><img
                          src="assets/images/icn-left.svg" class="image-fit" alt="Previous"></button>
                        </div>
                        <div class="icon-left" *ngIf="$any(item)?.timeSeriesData && appliedFilter?.period?.code === 'custom'">
                          <button mat-raised-button [ngClass]="{'graph-change-disable':item.moreRecords === false}"
                            class="prev-next-button" color="primary"
                            (click)="chartChange(item, item.chartfirstIndex,'next')"><img
                          src="assets/images/icn-right.svg" class="image-fit" alt="Next"></button>
                        </div> -->
                @if (isPaginatorVisible) {
                <app-chart-paginator [totalPoints]="totalPoints" (pagChange)="chartChange(item, $event)">
                </app-chart-paginator>
                }
            </div>
            }
        </div>
        }
        @if ((masterData | paramFilter : criticalityFilter?.AA : criticalityFilter?.A : criticalityFilter?.B :
        criticalityFilter?.C : parametersFilter.value)?.length && ((masterData?.length>5
        && parametersFilter.value.length>5 && appliedFilter?.period?.code !== 'custom')||
        (masterData?.length>1 && parametersFilter.value.length>1 && appliedFilter?.period?.code === 'custom'))) {
        <div class="page-change-button">
            @if (appliedFilter?.period?.code !== 'custom') {
            <button mat-raised-button [ngClass]="{'page-change-disable':firstIndex===0}" class="edit-btn spc-btn"
                color="primary" (click)="pageChange(firstIndex,'back')" class="button-separator">{{'common.back' |
                translate}}</button>
            }
            @if (appliedFilter?.period?.code === 'custom') {
            <span style="padding:5px 5px">Page :</span>
            }
            @if (appliedFilter?.period?.code === 'custom') {
            <div class="page-no">
                <mat-select [formControl]="pageno" (selectionChange)="pageNumChange()">
                    @for (data of masterData; track data; let pageno = $index) {
                    <mat-option [value]="pageno">
                        {{data?.parametername}}</mat-option>
                    }
                </mat-select>
            </div>
            }
            @if (appliedFilter?.period?.code !== 'custom') {
            <button mat-raised-button [ngClass]="{'page-change-disable':masterData?.length<=lastIndex}"
                class="edit-btn spc-btn" color="primary" (click)="pageChange(firstIndex,'next')">{{'common.next' |
                translate}}</button>
            }
        </div>
        }
        }
        @if (this.grapTypes==='summary' && isSummary) {
        <div class="graphs-cntnr">
            @if (summaryData) {
            <app-c3-summary-chart [data]="summaryData" [paramNameList]="this.parametersFilter.value">
            </app-c3-summary-chart>
            }
            @if (summaryData) {
            <app-summary-table [data]="summaryData" type="process" [paramNameList]="this.parametersFilter.value">
            </app-summary-table>
            }
        </div>
        }
        @if (this.grapTypes==='summary' && !isSummary) {
        <div class="no-data">
            <span>{{'common.statistics_no_Data' | translate}}.</span>
        </div>
        }
    </div>
</div>

<ng-template #custdateSelector>
    <app-custom-date-selector (applyDate)=applyCustomDate($event) [period]="statisticsForm.value?.period">
    </app-custom-date-selector>
</ng-template>